<template>
    <div class="simulador_passo_resultado">
        <h1>Planos</h1>
        <p class='center'>Selecionamos pra você planos que se aproximam do que você procura. Confira!</p>
        <div class="form-row">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 as_card" v-for="carta in cartas_compativeis" :key='carta.id'>
                <div>
                    <h3>{{ carta.tipo | tipo}}</h3>                    
                    <div class='show_on_mobile'>
                        <table class='table table-striped center'>
                            <tr><td class='resultado_titulo'>Crédito:</td></tr><tr><td>{{carta.credito | valor }}</td></tr>
                            <tr><td class='resultado_titulo'>Meses:</td></tr><tr><td>{{ carta.meses }} meses</td></tr>
                            <tr><td class='resultado_titulo'>Parcela:</td></tr><tr><td class='valor_adesao'>{{ carta.parcela | valor }}</td></tr>
                            <tr><td>Meia parcela <small>(até contemplar)</small>:</td></tr><tr><td>{{ carta.meia_parcela | valor }}</td></tr>
                            <tr><td class='resultado_titulo'>Adesão:</td></tr><tr><td class='valor_adesao'>{{ carta.adesao | valor }}</td></tr>                        
                        </table>
                    </div>
                    <div class='show_on_pc'>
                        <table class='table table-striped'>
                            <tr><td>Crédito:</td><td>{{carta.credito | valor }}</td></tr>
                            <tr><td>Meses:</td><td>{{ carta.meses }} meses</td></tr>
                            <tr><td>Parcela:</td><td class='valor_adesao'>{{ carta.parcela | valor }}</td></tr>
                            <tr><td>Meia parcela <small>(até contemplar)</small>:</td><td>{{ carta.meia_parcela | valor }}</td></tr>
                            <tr><td>Adesão:</td><td class='valor_adesao'>{{ carta.adesao | valor }}</td></tr>                        
                        </table>                    
                    </div>
                    <div class='center'>                        
                        <button class='btn btn-danger' @click='comprar(carta.id)'>Comprar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="btn_proximo">
                <button class='btn btn-secondary' @click='voltar'>Voltar</button>
                <button class='btn btn-danger' @click='reiniciar'>Simular novamente</button>
            </div>
        </div>         
    </div>
</template>

<script>
    export default {
        props:['lead'],
        data(){
            return{
                cartas_compativeis:[]
            }
        },
        methods:{
            voltar(){
                this.$emit('anterior');
            },
            reiniciar(){
                this.$emit('reiniciar');
            },
            carregar_cartas_compativeis(){

                axios.post('/api/apifront/cartascompativeis',this.lead)
                .then((data)=>{
                    this.cartas_compativeis = data.data;
                    console.log(this.cartas_compativeis);
                });

            },   
            comprar(id){

                var compra = {
                    'lead_id' : this.lead.id,
                    'carta_id' : id
                }

                axios.post('/api/apifront/comprarcarta',compra)
                .then((data)=>{
                    Swal.fire('Obrigado!','Um de nossos consultores entrará em contato com você para completarmos o seu cadastramento','success');
                    this.$emit('reiniciar');
                })
                .catch((error)=>{
                    Swal.fire('Compra não efetivada','Tivemos problemas para efetivar sua compra, tente novamente mais tarde.','error');
                })
            }
        },
        watch:{
            lead: function(newL,OldL){
                this.carregar_cartas_compativeis();
            }
        },
        mounted() {
            this.carregar_cartas_compativeis();
        }
    }
</script>
